import {
  Nullable,
  Undefinable,
  SessionInterface,
  BusinessUnitInterface,
  PaymentMethodInterface,
} from "../../interfaces";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserInterface } from "../../interfaces/UserInterface";
import { PaymentModeDto } from "../../interfaces/Dtos";

export interface UserState {
  businessUnit?: BusinessUnitInterface;
  paymentMethods?: PaymentMethodInterface[];
  paymentModes: PaymentModeDto[];
  retentionMethods?: PaymentMethodInterface[];
  user?: Nullable<UserInterface>;
  userLoginStartTime?: number; // milliseconds
  userSession?: Nullable<SessionInterface>;
}
export interface UserSessionInterface {
  user: UserInterface;
  session: SessionInterface;
}

const initialState: UserState = {
  user: null,
  userLoginStartTime: 0,
  userSession: null,
  paymentModes: [],
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserLocation: (
      state,
      action: PayloadAction<Undefinable<BusinessUnitInterface>>
    ) => {
      state.businessUnit = action.payload;
    },
    setPaymentMethods: (
      state,
      action: PayloadAction<PaymentMethodInterface[]>
    ) => {
      state.paymentMethods = action.payload;
    },
    setPaymentModes: (state, action: PayloadAction<PaymentModeDto[]>) => {
      state.paymentModes = action.payload;
    },
    setRetentionMethods: (
      state,
      action: PayloadAction<PaymentMethodInterface[]>
    ) => {
      state.retentionMethods = action.payload;
    },
    setUser: (state, action: PayloadAction<UserInterface>) => {
      state.user = action.payload;
    },
    login: (state, action: PayloadAction<UserSessionInterface>) => {
      state.user = action.payload.user;
      state.userSession = action.payload.session;
      state.userLoginStartTime = new Date().getTime();
    },
    logout: (state) => {
      state.user = null;
      state.businessUnit = undefined;
      state.userLoginStartTime = undefined;
      state.userSession = null;
    },
  },
});

export const {
  setUserLocation,
  setPaymentMethods,
  setPaymentModes,
  setRetentionMethods,
  login,
  logout,
  setUser,
} = userSlice.actions;

export default userSlice.reducer;
